<template>
  <div class="office-map relative">
    <div
      id="offie-map"
      class="rounded-2xl"
      :class="{ showonmobile: show || showMap }"
    ></div>
    <div
      v-if="!!highlighted.length"
      class="absolute bottom-0 offer-bar hidden md:block"
    >
      <div
        class="flex-col xl:flex-row flex text-center xl:text-left gap-2 justify-between px-3 py-3 items-center"
      >
        <div class="text-lg">
          Érdeklődöm a(z) {{ highlighted.length }} megjelölt irodáról
        </div>
        <div class="flex gap-3">
          <Button
            v-if="listType === 'offices'"
            class="white"
            @click="deselectAll"
            >Mégse</Button
          >
          <Button
            :class="[listType == 'offices' ? 'black' : 'white']"
            @click="toggleList"
            >{{ listType === "offices" ? "Kosár" : "Összes" }}</Button
          >
          <Button
            v-if="listType === 'cart'"
            class="black"
            @click="$emit('askOffer')"
            >OK</Button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import Button from "@/components/inputs/Button.vue";
import gmapStyles from "../../utils/gmapStyles";
import { drawOverlay, removeOverlays } from "../../utils/gmapOverlays";
import overlayTemplage from "../../utils/overlayTemplate";
// import { MarkerClusterer } from "@googlemaps/markerclusterer";
import slugify from "slugify";

let google;

const mapOptions = {
  scrollwheel: true,
  streetViewControl: false,
  mapTypeControl: false,
  fullscreenControl: false,
  styles: gmapStyles,
  zoom: 13,
  gestureHandling: "greedy"
};

export default {
  components: { Button },
  name: "OfficeMap",
  props: ["offices", "zoom", "frozen", "show"],
  data() {
    return {
      map: null,
      metersPerPixel: 0,
      selectedMarkerId: null,
      showMap: false,
      prevShowMap: null,
      markers: []
    };
  },
  computed: {
    ...mapState({
      highlighted: state => state.offices.highlighted,
      listType: state => state.offices.listType
    })
  },
  created() {},
  watch: {
    offices: {
      immediate: true,
      deep: true,
      handler(value) {
        this.selectedMarkerId = null;
        removeOverlays();
        this.setMarkers();
      }
    }
  },
  methods: {
    async initGoogle(googleInstance) {
      const mapElement = document.getElementById("offie-map");
      google = googleInstance;
      mapOptions.center = new google.maps.LatLng(
        47.49791200000001,
        19.040235000000013
      );
      if (this.show) {
        mapOptions.zoomControl = false;
        // mapOptions.draggable = false;
        // mapOptions.scrollwheel = false;
        // mapOptions.panControl = false;
      }
      mapOptions.zoomControlOptions = {
        position: google.maps.ControlPosition.RIGHT_CENTER
      };
      if (this.zoom) {
        mapOptions.zoom = this.zoom;
      }
      this.map = new google.maps.Map(mapElement, mapOptions);

      // ALTER
      if (this.show) {
        this.infoWindow = new google.maps.InfoWindow({
          content: "",
          disableAutoPan: true
        });
      }

      const transitLayer = new google.maps.TransitLayer();
      transitLayer.setMap(this.map);

      const { spherical } = await google.maps.importLibrary("geometry");

      google.maps.event.addListener(this.map, "idle", () => {
        for (const otherOverlay of mapElement.querySelectorAll(
          ".office-overlay"
        )) {
          otherOverlay.classList.remove("office-overlay--opened");
          otherOverlay.parentNode.classList.remove("office-overlay--z-index");
        }

        this.selectedMarkerId = null;

        const lat = this.map.getCenter().lat();
        const lng = this.map.getCenter().lng();
        const zoom = this.map.getZoom();

        this.metersPerPixel =
          (156543.03392 * Math.cos((lat * Math.PI) / 180)) / Math.pow(2, zoom);
        // const mapWidth = mapElement.offsetWidth;
        // const mapHeight = mapElement.offsetHeight;
        // const mapRadius = Math.round(Math.sqrt(mapWidth * mapWidth + mapHeight * mapHeight) / 2);
        // const distanceInMeters = this.metersPerPixel * mapRadius;

        const ne = this.map.getBounds().getNorthEast();
        const center = this.map.getCenter();
        const dist = spherical.computeDistanceBetween(ne, center);

        this.$emit("updated", lat, lng, zoom, Math.floor(dist));
      });

      google.maps.event.addListener(this.map, "click", event => {
        for (const otherOverlay of mapElement.querySelectorAll(
          ".office-overlay"
        )) {
          otherOverlay.classList.remove("office-overlay--opened");
          otherOverlay.parentNode.classList.remove("office-overlay--z-index");
          // this.selectedMarkerId = null;
        }

        if (event.tb) {
          event.tb.stopPropagation();
        }
      });

      google.maps.event.addListener(this.map, "bounds_changed", event => {
        for (const otherOverlay of mapElement.querySelectorAll(
          ".office-overlay"
        )) {
          otherOverlay.classList.remove("office-overlay--opened");
          otherOverlay.parentNode.classList.remove("office-overlay--z-index");
          this.selectedMarkerId = null;
        }
      });
    },
    setMarkers() {
      const that = this;

      if (this.show) {
        this.markers.forEach(m => m.marker.setMap(null));

        this.markers = this.offices.map(office => {
          const marker = new google.maps.Marker({
            position: { lat: office.lat, lng: office.long },
            icon: "/assets/img/office-marker-opened.95d82039.svg",
            map: that.map
          });

          marker.addListener("click", () => {
            that.infoWindow.setContent(`
                <div style="background: linear-gradient(180.29deg, #f0f0f0 0.25%, #cfcfcf 99.75%); border: 3px solid rgba(255, 255, 255, 1); box-shadow: 0px 6px 50px rgba(0, 0, 0, 0.25); border-radius: 10px; width: 258px;">
                  <div style="display: flex;" id="office-info-${office.id}">
                    <img style="width: 130px; min-height: 100%; object-fit: cover; border-radius: 10px 0 0 10px" src="${process
                      .env.VUE_APP_API_URL + office.mainImage?.url}">
                    <div style="display: flex; flex-direction: column; width: 100%">
                      <div style="padding: 10px; text-align: left;">
                        <h3 style="margin: 0; font-weight: 600; font-size: 14px; line-height: 13px; color: #525252">${
                          office.name
                        }</h3>
                        <p style="font-weight: 400;font-size: 12px;line-height: 100%;color: #838383;">${
                          office.postalCode
                        } ${office.city},<br>${office.addressLine}</p>
                      </div>
                      <div style="text-align: center;">
                        <span style="display: block; background: rgba(82, 82, 82, 0.5); border-radius: 0 0 10px; font-weight: 700; font-size: 20px; line-height: 18px; color: white;">
                          <img src="/assets/img/offierating.4125aa87.png" style="height: 25px;vertical-align: -9px;margin-right: 16px;margin-top: 4px;margin-bottom: 3px;">
                          ${office.offieRating ? office.offieRating : "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              `);

            that.infoWindow.open(that.map, marker);
            // setTimeout(() => {
            //   const info = document.getElementById(
            //     `office-info-${office.id}`
            //   );
            //   info.addEventListener("click", () =>
            //     that.$router.push("/irodak/" + office.id)
            //   );
            // }, 500);
          });

          return { office: office.id, marker };
        });
      } else {
        const offices = this.offices;
        this.offices.forEach(office => {
          drawOverlay(google, this.map, {
            lat: office.lat,
            lng: office.long,
            verticalAlign: "top",
            horizontalAlign: "center",
            layer: "overlayMouseTarget",
            content: overlayTemplage(office),
            click: function(overlay, event) {
              event.stopPropagation();

              const thisOverlay = overlay.el.querySelector(".office-overlay");
              const mapElement = document.getElementById("offie-map");

              const pinRect = thisOverlay.getBoundingClientRect();
              const mapRect = mapElement.getBoundingClientRect();

              if (that.selectedMarkerId == thisOverlay.dataset.id) {
                const office = offices.find(
                  o => o.id == thisOverlay.dataset.id
                );
                that.$router.push(
                  "/irodak/" +
                    `${slugify(office.name, {
                      replacement: "_",
                      lower: true
                    })}-${office.id}`
                );
                return;
              }

              for (const otherOverlay of overlay.el.parentNode.querySelectorAll(
                ".office-overlay"
              )) {
                otherOverlay.classList.remove("office-overlay--opened");
                otherOverlay.parentNode.classList.remove(
                  "office-overlay--z-index"
                );
              }

              that.selectedMarkerId = thisOverlay.dataset.id;
              thisOverlay.classList.add("office-overlay--opened");
              thisOverlay.parentNode.classList.add("office-overlay--z-index");

              const infowindow = thisOverlay.querySelector(
                ".office-infowindow"
              );

              const left = pinRect.left - mapRect.left;
              const right = pinRect.right - mapRect.right;
              const bottom = pinRect.bottom - mapRect.bottom;

              if (left - 132 < 0) {
                infowindow.style.left = "0px";
              }
              if (-right - 132 < 0) {
                infowindow.style.left = "-264px";
              }
              if (bottom > -120) {
                infowindow.style.top = "-128px";
              }
            }
          });
        });
      }
    },
    setBounds(place) {
      if (place.geometry.viewport) {
        this.map.fitBounds(place.geometry.viewport);
        this.map.setZoom(15);
      } else {
        this.map.setCenter(place.geometry.location);
      }
    },
    fitBounds(bounds) {
      this.map.fitBounds(bounds);
    },
    setCenter(bounds) {
      this.map.setCenter(bounds);
    },
    setZoom(zoom) {
      this.map.setZoom(zoom);
    },
    setZoomFromDistance(distance) {
      const lat = this.map.getCenter().lat();
      const km = distance / 1000;
      const zoom = Math.round(
        Math.log2((38000 * Math.cos((lat * Math.PI) / 180)) / km) + 3
      );
      this.map.setZoom(zoom);
    },
    highligh(office) {
      if (this.show) {
        if (office) {
          const marker = this.markers.find(m => m.office == office.id);
          marker.marker.setAnimation(google.maps.Animation.BOUNCE);
        } else {
          this.markers.forEach(m => m.marker.setAnimation(null));
        }
      } else {
        const mapElement = document.getElementById("offie-map");
        if (office) {
          const highlightedOverlay = mapElement.querySelector(
            `.office-overlay[data-id="${office.id}"]`
          );
          highlightedOverlay.classList.add("office-overlay--highlighted");
          highlightedOverlay.parentNode.classList.add(
            "office-overlay--z-index"
          );
        } else {
          for (const otherOverlay of mapElement.querySelectorAll(
            ".office-overlay"
          )) {
            otherOverlay.classList.remove("office-overlay--highlighted");
            otherOverlay.parentNode.classList.remove("office-overlay--z-index");
          }
        }
      }
    },
    deselectAll() {
      this.$store.commit("offices/deselectAll");
    },
    toggleList() {
      this.$store.commit("offices/toggleListType");
    },
    showOnMobile(showMap) {
      this.showMap = showMap;
    }
  }
};
</script>

<style lang="scss">
.office-map {
  grid-area: map;
  .offer-bar {
    background: $blue;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    width: 100%;
    color: white;
  }
}

.gm-style .gm-style-iw-c {
  padding: 0 !important;
  max-width: 500px !important;
}

.gm-style-iw-d {
  overflow: auto !important;
}

#offie-map {
  height: 100%;

  @media (max-width: $breakpoint2) {
    height: 0;

    &.showonmobile {
      height: calc(100vh - 84px);
      display: block;
    }
  }

  .office-overlay--z-index {
    z-index: 5000 !important;
  }

  .office-overlay {
    .office-marker {
      display: inline;
      cursor: pointer;
      width: 16px;
      margin: -7px 0 0 -7px;
    }

    .office-opened-marker {
      display: none;
      width: 30px;
      margin: -15px 0 0 -15px;
    }

    .office-infowindow {
      display: none;
      left: -132px;
      position: absolute;
      top: 18px;

      background: linear-gradient(180.29deg, #f0f0f0 0.25%, #cfcfcf 99.75%);
      border: 3px solid rgba(255, 255, 255, 1);
      box-shadow: 0px 6px 50px rgba(0, 0, 0, 0.25);
      border-radius: 10px;
      width: 258px;
      letter-spacing: -0.5px;

      img.office-infowindow__picture {
        width: 130px;
        min-height: 100%;
        object-fit: cover;
        border-radius: 10px 0 0 10px;
      }

      h3 {
        margin: 0;
        font-weight: 600;
        font-size: 11px;
        line-height: 10px;
        color: #525252;
      }

      p {
        font-weight: 400;
        font-size: 10px;
        line-height: 100%;
        color: #838383;
      }

      .office-infowindow__offie-rating {
        text-align: center;

        span {
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba(82, 82, 82, 0.5);
          border-radius: 0 0 10px 0;

          font-weight: 700;
          font-size: 20px;
          line-height: 18px;
          color: white;

          img {
            height: 25px;
            // vertical-align: -9px;
            margin-right: 16px;
            margin-top: 4px;
            margin-bottom: 2px;
          }
        }
      }
    }

    &.office-overlay--highlighted {
      .office-marker {
        display: none;
      }

      .office-opened-marker {
        display: inline;
      }
    }

    &.office-overlay--opened {
      .office-marker {
        display: none;
      }

      .office-opened-marker {
        display: inline;
      }

      .office-infowindow {
        display: block;
        cursor: pointer;
        font-family: "Lexend Exa", Arial;
      }
    }
  }
}
</style>
